export default __webpack_public_path__ + "static/media/Instagram.87bfe6fc.png";